/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Username_In_UseInputs */



/**

* @param {Username_In_UseInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const username_in_use = /** @type {((inputs?: Username_In_UseInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Username_In_UseInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Dieser Benutzername wird bereits verwendet.")
});